import { Injectable } from '@angular/core';
import { ExamAgencyHttpService } from './exam-agency-http.service';
import { catchError, map } from 'rxjs/operators';
import { IExamAgency } from '../interfaces/exam-agency.interface';
import { of, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import {
  HttpErrorUtil,
  HttpUnauthorizedException,
} from 'src/app/utils/http-util/http-error.util';
import { ToastrService } from 'ngx-toastr';
import { UserAuthManager } from '../../../../Services/user-sessions/user-auth-manager';
import { AuthService } from 'src/app/Services/services/auth.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ExamAgencyService {
  constructor(
    private readonly examAgencyHttpService: ExamAgencyHttpService,
    private readonly toaster: ToastrService,
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  getExamAgenciesList<T>(loggedInUserID: string) {
    return this.examAgencyHttpService.getExamAgencyList<T>(loggedInUserID).pipe(
      catchError((err: HttpErrorResponse) => this.handlerError(err)),
      map((data) => {
        return data;
      })
    );
  }

  getCourseMasterList<T>(loggedInUserId: string, examAgencyId: number) {
    return this.examAgencyHttpService
      .getCourseMasterList<T>(loggedInUserId, examAgencyId)
      .pipe(
        catchError((err: HttpErrorResponse) => this.handlerError(err)),
        map((data) => {
          return data;
        })
      );
  }

  private handlerError(err: HttpErrorResponse) {
    const error = HttpErrorUtil.sanitizeError(err);

    if (error instanceof HttpUnauthorizedException) {
      UserAuthManager.userSessionLogout.next();
      this.authService.logout();
      this.router.navigate(['/login']);
      this.toaster.warning(error.message, 'Logout Successfully');
    } else {
      this.toaster.error(error.message, 'Error');
    }

    return throwError(error);
  }
}
